import React from "react";

// Import Images (Adjust Paths as Needed)
import userDashboard from "../../assets/user-dashboard.png";
import trailerDetails from "../../assets/trailer-details.png";
import trailerUpdate from "../../assets/trailer-update.png";
import trucksDashboard from "../../assets/trucks-dashboard.png";
import buildingsDashboard from "../../assets/buildings-dashboard.png";
import buildingDetail from "../../assets/building-detail.png";
import adminTrailers from "../../assets/admin-dashboard-trailers.png";
import adminTrailerAdd from "../../assets/admin-trailer-add.png";
import adminTrucks from "../../assets/admin-dashboard-trucks.png";
import adminTruckDetail from "../../assets/admin-truck-details.png";
import adminTruckUpdate from "../../assets/admin-truck-details.png";
import adminTruckAddLocation from "../../assets/admin-truck-add-location.png";
import adminTruckAdd from "../../assets/admin-truck-add.png";
import yardDetail from "../../assets/admin-yard-detail.png";
import yardUpdate from "../../assets/admin-yard-update.png";
import auditLogs from "../../assets/audit-logs-dashboard.png";

function HowTo() {
  return (
    <div className="user-manual lg:max-w-8xl w-full mx-auto p-12 bg-white shadow rounded-lg text-gray-900 font-sans text-2xl">

      {/* Header */}
      <header className="mb-10">
        <h1 className="text-7xl font-bold text-center text-blue-600 leading-snug">
          ModernTech YMS - User Manual
        </h1>
        <h4 className="text-3xl text-center text-gray-700 mt-2">
          [ Yard Management System (YMS) ]
        </h4>
        <p className="mt-4 leading-relaxed text-gray-700 text-center">
          Thank you for choosing Modern Technology trucking management system. This manual provides a comprehensive overview of the application's features and functions.
        </p>
      </header>

      {/* Table of Contents */}
      <nav className="mb-10">
        <h2 className="text-4xl font-semibold mb-4 text-gray-800">Table of Contents</h2>
        <ul className="list-disc list-inside leading-relaxed space-y-2">
          <li>
            <a href="#general-guide" className="text-blue-600 hover:underline">
              General Guide
            </a>
          </li>
          <li>
            <a href="#dashboard" className="text-blue-600 hover:underline">
              Features
            </a>
          </li>
          <li>
            <a href="#admin-guide" className="text-blue-600 hover:underline">
              Admin Guide
            </a>
          </li>
          <li>
            <a href="#admin-dashboard" className="text-blue-600 hover:underline">
              Admin Features
            </a>
          </li>
          <li>
            <a href="#troubleshooting" className="text-blue-600 hover:underline">
              Troubleshooting
            </a>
          </li>
          <li>
            <a href="#contact-us" className="text-blue-600 hover:underline">
              Contact Us
            </a>
          </li>
        </ul>
      </nav>

      {/* Divider */}
      <hr className="my-12 border-t border-gray-300" />

      {/* General Guide Section */}
      <section id="general-guide" className="mb-10">
        <h2 className="text-4xl font-semibold text-gray-800 mb-4">General Guide</h2>
        <h4 className="text-3xl text-gray-700 mb-6 leading-relaxed">
          This guide highlights the main features of the Trucking Management System for non-Admin users.
        </h4>

        <article className="mb-8">
          <h3 className="text-4xl font-bold text-gray-800">Dashboard</h3>
          <p className="mt-2 leading-relaxed text-gray-700">
            Upon login, users will be taken to the dashboard. It displays information for trailers, trucks, yards, and buildings associated with your company.
          </p>
          <p className="mt-2 leading-relaxed text-gray-700">
            The interface serves as an all-in-one retrieval of information.
          </p>
        </article>

        <article className="mb-8">
          <h3 className="text-4xl font-bold text-gray-800">Trailers Dashboard</h3>
          <img src={userDashboard} alt="User Dashboard" className="mt-4 rounded-lg shadow" />
        </article>

        <article className="mb-8">
          <h3 className="text-4xl font-bold text-gray-800">Trailer Details</h3>
          <img src={trailerDetails} alt="Trailer Details" className="mt-4 rounded-lg shadow" />
          <p className="mt-2 leading-relaxed text-gray-700">
            Each entry features the trailer's details, including its current location and maintenance history.
          </p>
        </article>

        <article className="mb-8">
          <h3 className="text-4xl font-bold text-gray-800">Update Trailer</h3>
          <img src={trailerUpdate} alt="Edit Trailer" className="mt-4 rounded-lg shadow" />
          <p className="mt-2 leading-relaxed text-gray-700">
            Entries can be modified and updated to suit your requirements.
          </p>
        </article>

        <article className="mb-8">
          <h3 className="text-4xl font-bold text-gray-800">Trucks</h3>
          <img src={trucksDashboard} alt="Trucks Dashboard" className="mt-4 rounded-lg shadow" />
          <p className="mt-2 leading-relaxed text-gray-700">
            Truck information and statuses are available to all users.
          </p>
        </article>

        <article className="mb-8">
          <h3 className="text-4xl font-bold text-gray-800">Buildings</h3>
          <img src={buildingsDashboard} alt="Buildings Dashboard" className="mt-4 rounded-lg shadow" />
          <img src={buildingDetail} alt="Building Detail" className="mt-4 rounded-lg shadow" />
          <p className="mt-2 leading-relaxed text-gray-700">
            Building information is available upon selection.
          </p>
        </article>
      </section>

      {/* Divider */}
      <hr className="my-12 border-t border-gray-300" />

      {/* Admin Guide Section */}
      <section id="admin-guide" className="mb-12">
        <h2 className="text-4xl font-semibold text-gray-800 mb-4">Admin Guide</h2>
        <h3 className="text-3xl font-bold text-gray-800 mb-4">ADMIN Table of Contents</h3>
        <ul className="list-disc list-inside text-xl space-y-2 mb-6">
          <li>
            <a href="#admin-dashboard" className="text-blue-600 hover:underline">
              Admin Dashboard
            </a>
          </li>
          <li>
            <a href="#accounts" className="text-blue-600 hover:underline">
              Accounts
            </a>
          </li>
          <li>
            <a href="#audit-logs" className="text-blue-600 hover:underline">
              Audit Logs
            </a>
          </li>
          <li>
            <a href="#entry-logs" className="text-blue-600 hover:underline">
              Entry Logs
            </a>
          </li>
          <li>
            <a href="#exit-logs" className="text-blue-600 hover:underline">
              Exit Logs
            </a>
          </li>
          <li>
            <a href="#trailers-1" className="text-blue-600 hover:underline">
              Trailers
            </a>
          </li>
          <li>
            <a href="#trucks-1" className="text-blue-600 hover:underline">
              Trucks
            </a>
          </li>
        </ul>

        <article id="admin-dashboard" className="mb-8">
          <h2 className="text-4xl font-semibold text-gray-800 mb-4">Admin Dashboard</h2>

          <article className="mb-8">
            <h3 className="text-3xl font-bold text-gray-800">Trailers</h3>
            <h4 className="text-2xl text-gray-700 mt-2">Trailer Dashboard - Displays trailer details per account.</h4>
            <img src={adminTrailers} alt="Admin Trailer Dashboard" className="mt-4 rounded-lg shadow" />
          </article>

          <article className="mb-8">
            <h4 className="text-2xl font-semibold text-gray-800">Add New Trailer</h4>
            <p className="text-xl text-gray-600 mt-2">Adds trailer to account and features status tags.</p>
            <img src={adminTrailerAdd} alt="Admin Add Trailer" className="mt-4 rounded-lg shadow" />
          </article>

          <article className="mb-8">
            <h3 className="text-3xl font-bold text-gray-800">Trucks</h3>
            <h4 className="text-2xl text-gray-700 mt-2">Trucks Dashboard - Shows truck details per account.</h4>
            <img src={adminTrucks} alt="Admin Truck Dashboard" className="mt-4 rounded-lg shadow" />
          </article>

          <article className="mb-8">
            <h4 className="text-2xl font-semibold text-gray-800">Truck Details</h4>
            <img src={adminTruckDetail} alt="Admin Truck Detail" className="mt-4 rounded-lg shadow" />
          </article>

          <article className="mb-8">
            <h4 className="text-2xl font-semibold text-gray-800">Update Truck</h4>
            <img src={adminTruckUpdate} alt="Admin Truck Update" className="mt-4 rounded-lg shadow" />
          </article>

          <article className="mb-8">
            <h4 className="text-2xl font-semibold text-gray-800">Add New Truck</h4>
            <p className="text-xl text-gray-600 mt-2">Adds truck to account and includes status tags.</p>
            <img src={adminTruckAddLocation} alt="Add Truck Button" className="mt-4 rounded-lg shadow" />
            <img src={adminTruckAdd} alt="Add Truck" className="mt-4 rounded-lg shadow" />
          </article>
        </article>
      </section>

      {/* Divider */}
      <hr className="my-12 border-t border-gray-300" />

      {/* Yard Section */}
      <section id="yard" className="mb-12">
        <h2 className="text-4xl font-semibold text-gray-800 mb-4">Yard</h2>
        <img src={yardDetail} alt="Yard Dashboard" className="mt-4 rounded-lg shadow" />
        <article className="mt-8">
          <h4 className="text-2xl font-semibold text-gray-800">Update Yard</h4>
          <img src={yardUpdate} alt="Admin Edit Yard" className="mt-4 rounded-lg shadow" />
        </article>
      </section>

      {/* Divider */}
      <hr className="my-12 border-t border-gray-300" />

      {/* Audit Logs Section */}
      <section id="audit-logs" className="mb-12">
        <h2 className="text-4xl font-semibold text-gray-800 mb-4">Audit Logs</h2>
        <p className="text-xl text-gray-600 mb-4">
          Every creation, edit, or deletion is logged along with entry and exit logs.
        </p>
        <img src={auditLogs} alt="Audit Logs" className="mt-4 rounded-lg shadow" />
      </section>

      {/* Divider */}
      <hr className="my-12 border-t border-gray-300" />

      {/* Contact Us Section */}
      <section id="contact-us" className="mb-12">
        <h2 className="text-4xl font-semibold text-gray-800 mb-4">Contact Us</h2>
        <p className="text-xl text-gray-600">
          For support and further information, please contact{" "}
          <a href="mailto:support@moderntech.com" className="text-blue-600 hover:underline">
            support@moderntech.com
          </a>.
        </p>
      </section>
    </div>
  );
}

export default HowTo;
